export const REFRESH_USER_COUNT = "REFRESH_USER_COUNT";

import { format } from "date-fns";
import { get, put, post, destroy, upload } from "utils/fetchRequest";

// Огноог query-д аюулгүй, цагийн бүсийн зөрүүгүй хэлбэрээр явуулна
// (Date.toString()-ийн "+" тэмдэг query-д зай болж 8 цагийн зөрүү үүсгэдэг байсан)
const toDateParam = (d) => {
  if (!d) return "";
  try {
    return format(d, "yyyy-MM-dd HH:mm:ss");
  } catch (e) {
    return "";
  }
};

export const uploadImage = async (data) => {
  try {
    const result = await upload("files/news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const buildNewsQuery = (
  searchText,
  type,
  authorId,
  page,
  pageLimit,
  role,
  userRole,
  branch,
  startDate,
  endDate,
  income,
  distributed,
  sort,
  dir
) =>
  `1=1${searchText ? `&search=${encodeURIComponent(searchText)}` : ""}${page ? `&page=${page}` : ""}${pageLimit ? `&limit=${pageLimit}` : ""}${type ? `&type=${type}` : ""}${role ? `&branch=${role}` : ""}${userRole ? `&userRole=${userRole}` : ""}${branch ? `&branchIdUser=${branch}` : ""}${startDate ? `&startDate=${encodeURIComponent(toDateParam(startDate))}` : ""}${endDate ? `&endDate=${encodeURIComponent(toDateParam(endDate))}` : ""}${income ? `&income=${encodeURIComponent(income)}` : ""}${distributed ? `&distributed=${encodeURIComponent(distributed)}` : ""}${sort ? `&sort=${sort}&dir=${dir || "desc"}` : ""}`;

export const getNewsList = async (
  searchText,
  type,
  authorId,
  page,
  pageLimit,
  role,
  userRole,
  branch,
  startDate,
  endDate,
  income,
  distributed,
  sort,
  dir
) => {
  try {
    const result = await get(
      `news?${buildNewsQuery(searchText, type, authorId, page, pageLimit, role, userRole, branch, startDate, endDate, income, distributed, sort, dir)}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsDelivery = async (searchText) => {
  try {
    const result = await get(
      `news/delivery?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListUser = async (searchText) => {
  try {
    const result = await get(
      `news/count?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsListNo = async (searchText) => {
  try {
    const result = await get(
      `news/countNo?1=1${searchText ? `&search=${searchText}` : ""}`
    );

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const getNewsContent = async (newsId) => {
  try {
    const result = await get(`news/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setNewsSeen = async (newsId) => {
  try {
    const result = await put(`news/seen/${newsId}`);
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const createNews = async (data) => {
  try {
    const result = await post("news", data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNews = async (id, data) => {
  try {
    const result = await put(`news/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const updateNewsDelivery = async (data) => {
  try {
    const result = await put(`news/deliveryupdate/${data.datas}`, {
      data: data,
    });
    return result;
  } catch (err) {
    return { error: err };
  }
};

export const deleteNews = async (id) => {
  try {
    const result = await destroy(`news/${id}`);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const setSpecial = async (id, data) => {
  try {
    const result = await put(`news/special/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};

export const status = async (id, data) => {
  try {
    const result = await put(`news/status/${id}`, data);

    return result;
  } catch (err) {
    return { error: err };
  }
};
